import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { Commonvariable } from 'src/app/commonvariable/commonvariable';
import { RentbillService } from 'src/app/_services/rentbill/rentbill.service';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';

@Component({
  selector: 'app-viewrentinvoice',
  templateUrl: './viewrentinvoice.component.html',
  styleUrls: ['./viewrentinvoice.component.css'],
  providers: [Commonvariable, CustomLoaderCComponent]
})
export class ViewrentinvoiceComponent implements OnInit {
  @ViewChild('invoicetemplate') contentPDF: ElementRef;
  idBillmaster: string;
  constructor(
    private router: ActivatedRoute,
    private spinner: CustomLoaderCComponent,
    private billService: RentbillService,
    public dateconfig: Dateconfig,
    private Commonvariable: Commonvariable,

  ) { }
  public breadcrumb: any = {};
  public model: any = {}
  public listBillItems: any = [];
  public listPayment: any = [];
  public totalGSTAmount;
  public totalPriceWithoutGST;
  public totalQty;
  public currency = this.Commonvariable.currency;

  ngOnInit() {

    this.spinner.showSpinner();
    this.idBillmaster = this.router.snapshot.queryParamMap.get('Id');
    this.idBillmaster = atob(this.idBillmaster);

    this.totalGSTAmount = 0
    this.totalPriceWithoutGST = 0;
    this.totalQty = 0;

    this.billService.GetBillById(Number(this.idBillmaster)).subscribe(Response => {

      this.model = Response;
      this.model.billDate = this.dateconfig.shortyydd(this.model.billDate);

      window.setTimeout(function () {

      }, 0);

      this.listBillItems = Response.listRentBillItems;
      this.model.totalgst = 0

      for (var i = 0; i < this.listBillItems.length; i++) {
        this.listBillItems[i].productToalGSTAmount = Number((this.listBillItems[i].productToalGSTAmount).toFixed(2))
        this.model.totalgst = this.model.totalgst + this.listBillItems[i].productToalGSTAmount;
        this.totalQty = this.totalQty + this.listBillItems[i].productQty;
      }
      this.totalPriceWithoutGST = this.model.totalAmountIncGST - this.model.totalgst;
      this.listPayment = Response.listPayment;
      if (this.listPayment == null) {
        this.listPayment = [];
      }
      this.model.totalAmountIncGST = Math.round(this.model.totalAmountIncGST);
      this.model.balanceAmount = Math.round(this.model.balanceAmount);
      this.totalPriceWithoutGST = (this.totalPriceWithoutGST).toFixed(2);
      this.spinner.hideSpinner();
    });
  }
  
  getPrint(invoice) {
    const printContents = document.getElementById(invoice).innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;

    document.title = this.model.displayBillNumber;


    window.print();
    document.body.innerHTML = originalContents;

    location.reload();
  }

}
